module.exports = __webpack_public_path__ + "static/media/mapKTH.30bd5560.pdf";